import { render, staticRenderFns } from "./ConfigurationDropdown.vue?vue&type=template&id=581fc505&"
import script from "./ConfigurationDropdown.vue?vue&type=script&lang=js&"
export * from "./ConfigurationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports